import React, { useContext, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addToCart, clearCart, removeFromCart } from '../redux/slices/Cart/CartSlice';
import { markItemAsAdded, resetAddedToCart, unmarkItemAsAdded } from '../redux/slices/Cart/CartUISlice';
import { AuthContext } from '../context/AuthContext';
import CartSyncHandler from './CartSyncHandler';
import { OrderRequestAPI } from '../redux/actions/Cart/OrderRequestAction';
import { showErrorToast, showSuccessToast } from '../helpers/SweetAlert';
import { orderStateReset } from '../redux/slices/Cart/OrderRequestSlice';
import backend_url from '../services/endpoints';

const Cart = () => {
    const dispatch = useDispatch();
    const modalRef = useRef();
    const cartItems = useSelector((state) => state.cart.items);

    const isHandleSubmit = cartItems.length > 0 ? true : false;
    const { response: orderRequestResponse, error: orderRequestError } = useSelector((state) => state.orderRequest);

    const [selectedDate, setSelectedDate] = useState('');
    const [selectedTime, setSelectedTime] = useState('');
    const [validationErrors, setValidationErrors] = useState('');
    const [bottomBar, setBottomBar] = useState(false);
    const [timeField, setTimeField] = useState(false);
    const [dateField, setDateField] = useState(false);
    const [monthField, setMonthField] = useState(false);
    const [week, setWeek] = useState(false);
    const [recurringTime, setRecurringTime] = useState('');

    const [recurring, setRecurring] = useState(cartItems.length > 0 ? true : false);

    const [value, setValue] = useState('');
    const [selectedWeekdays, setSelectedWeekdays] = useState([]);
    const [selectedWeek, setSelectedWeek] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');

    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    // const days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];

    const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    const weeks = [1, 2, 3, 4, 5]

    const subtotal = cartItems?.reduce((acc, item) => {
        const price = parseFloat(item.price) || 0;
        const quantity = parseInt(item.quantity) || 0;
        return acc + price * quantity;
    }, 0);

    const validateForm = () => {
        const newErrors = {};

        if (!selectedDate) newErrors.date = true;
        if (!selectedTime) newErrors.time = true;
        setValidationErrors(newErrors);

        return Object.keys(newErrors).length === 0; // true if no errors
    };

    // const handleSubmitRequest = async () => {

    //     if (!validateForm()) {
    //         return;
    //     }

    //     const supplierId = cartItems[0].supplierId;

    //     const requestedProducts = await cartItems.map((item) => {
    //         return {
    //             productId: item._id,
    //             price: item.price,
    //             quantity: item.quantity
    //         }
    //     })

    //     let isRecurring;
    //     let recurringType;
    //     let recurringTimeToSend;
    //     let recurringDay;
    //     let whichWeekOfMonth;
    //     let whichMonthOfYear;
    //     let payload;
    //     if (value) {
    //         switch (value) {
    //             case 'no repeat':
    //                 isRecurring = true;
    //                 recurringType = 0;
    //                 return payload = { supplierId: supplierId, requestedProducts: requestedProducts, scheduledDate: selectedDate, scheduledTime: selectedTime, totalPrice: subtotal, isRecurring: isRecurring, recurringType: recurringType }
    //                 break;
    //             case 'every weekday':
    //                 isRecurring = true;
    //                 recurringType = 1;
    //                 recurringTimeToSend = recurringTime;
    //                 recurringDay = selectedWeekdays;
    //                 return payload = { supplierId: supplierId, requestedProducts: requestedProducts, scheduledDate: selectedDate, scheduledTime: selectedTime, totalPrice: subtotal, isRecurring: isRecurring, recurringType: recurringType }
    //                 break;
    //             case 'monthly':
    //                 isRecurring = true;
    //                 recurringType = 4;
    //                 recurringTimeToSend = recurringTime;
    //                 recurringDay = selectedWeekdays;
    //                 whichWeekOfMonth = selectedWeek;
    //                 return payload = { supplierId: supplierId, requestedProducts: requestedProducts, scheduledDate: selectedDate, scheduledTime: selectedTime, totalPrice: subtotal, isRecurring: isRecurring, recurringType: recurringType, recurringDay: recurringDay, recurringTime: recurringTimeToSend, whichWeekOfMonth: whichWeekOfMonth }
    //                 break;
    //             case 'yearly':
    //                 isRecurring = true;
    //                 recurringType = 4;
    //                 recurringTimeToSend = recurringTime;
    //                 recurringDay = selectedWeekdays;
    //                 whichWeekOfMonth = selectedWeek;
    //                 whichMonthOfYear = selectedMonth
    //                 return payload = { supplierId: supplierId, requestedProducts: requestedProducts, scheduledDate: selectedDate, scheduledTime: selectedTime, totalPrice: subtotal, isRecurring: isRecurring, recurringType: recurringType, recurringDay: recurringDay, recurringTime: recurringTimeToSend, whichWeekOfMonth: whichWeekOfMonth, whichMonthOfYear: whichMonthOfYear }
    //                 break;
    //         }
    //     }

    //     dispatch(OrderRequestAPI(payload));

    //     // if (selectedWeekdays && recurringTime) {
    //     //     dispatch(OrderRequestAPI({ supplierId: supplierId, requestedProducts: requestedProducts, scheduledDate: selectedDate, scheduledTime: selectedTime, totalPrice: subtotal, isRecurring: isRecurring, recurringType: recurringType, recurringDay: recurringDay, recurringTime: recurringTimeToSend }));
    //     // }
    //     // else {
    //     //     dispatch(OrderRequestAPI({ supplierId: supplierId, requestedProducts: requestedProducts, scheduledDate: selectedDate, scheduledTime: selectedTime, totalPrice: subtotal, isRecurring: isRecurring, recurringType: recurringType }));
    //     // }
    // }

    const handleSubmitRequest = async () => {
        if (!validateForm()) {
            return;
        }

        const supplierId = cartItems[0].supplierId;

        const requestedProducts = cartItems.map((item) => ({
            productId: item._id,
            price: item.price,
            quantity: item.quantity
        }));

        let payload = {
            supplierId,
            requestedProducts,
            scheduledDate: selectedDate,
            scheduledTime: selectedTime,
            totalPrice: subtotal,
            isRecurring: false, // default
        };

        if (value) {
            payload.isRecurring = true;

            switch (value) {
                case 'no repeat':
                    payload.recurringType = 0;
                    break;

                case 'every weekday':
                    payload.recurringType = 1;
                    payload.recurringTime = recurringTime;
                    payload.recurringDay = selectedWeekdays;
                    break;

                case 'monthly':
                    payload.recurringType = 4;
                    payload.recurringTime = recurringTime;
                    payload.recurringDay = selectedWeekdays;
                    payload.whichWeekOfMonth = selectedWeek;
                    break;

                case 'yearly':
                    payload.recurringType = 4;
                    payload.recurringTime = recurringTime;
                    payload.recurringDay = selectedWeekdays;
                    payload.whichWeekOfMonth = selectedWeek;
                    payload.whichMonthOfYear = selectedMonth;
                    break;

                default:
                    payload.isRecurring = false;
                    break;
            }
        }

        dispatch(OrderRequestAPI(payload));
    };

    const handleCheckboxChange = (day) => {
        setSelectedWeekdays(prev =>
            prev.includes(day)
                ? prev.filter(d => d !== day)
                : [...prev, day]
        );
    };


    useEffect(() => {
        if (orderRequestResponse?.status === true) {
            showSuccessToast(orderRequestResponse?.message);
            dispatch(orderStateReset());

            setSelectedDate('');
            setSelectedTime('');

            setValue('');
            setRecurringTime('');
            setSelectedWeekdays([]);
            setSelectedWeek('');
            setSelectedMonth('');

            cartItems.forEach(item => {
                dispatch(clearCart());
                dispatch(resetAddedToCart());
            });
        }
        if (orderRequestError) {
            showErrorToast(orderRequestError?.data);
            dispatch(orderStateReset());
        }
    }, [orderRequestResponse, orderRequestError])

    // useEffect(() => {
    //     $('#clockpicker').clockpicker();
    // }, [])

    const closeModal = () => {
        if (modalRef.current) {
            const modal = window.bootstrap.Modal.getInstance(modalRef.current);
            modal?.hide();
        }
        setRecurring(false);
    };

    return (
        <>
            <section className='main'>
                <div className='container'>
                    <div className='row gy-4'>
                        <div className='col-12'>
                            <div className='wrapper-card'>
                                <div className='row gy-4'>
                                    <div className='col-md-5'>
                                        <div className='status_card_wrapper hstack flex-wrap gap-4'>
                                            <CartSyncHandler />
                                            {cartItems ? cartItems?.map((c, index) => {
                                                return (

                                                    <div className='inner_outline_card hstack align-items-start m-0 position-relative w-100' key={index} >
                                                        <div className='product_item hstack align-items-start'>
                                                            <div className='product_img'>
                                                                <img src={c.img ? `${backend_url}${c.img}` : c.images.length > 0 ? `${backend_url}${c.images[0]}` : "/assets/images/fruit-apple.png"} alt={c.name || 'product'} />
                                                            </div>
                                                            <div className='product_info'>
                                                                <div className='product_title_blk'>
                                                                    <h3 className='product_name fs-6 fw-bold mb-0'>{c.name || 'N/A  '}</h3>
                                                                </div>
                                                                <ul className='product_title_info list-unstyled mb-0'>
                                                                    <li><span className='card_product_title fw-medium'>Quantity - </span><span className='card_value'>{c.quantity}</span></li>
                                                                    <li><span className='card_product_title fw-medium'>Type - </span><span className='card_value'>{c.productType || 'N/A'}</span></li>
                                                                    <li><span className='card_product_title fw-medium'>Price - </span><span className='card_value'>{c.price ? `$${c.price}` : 'N/A'}</span></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div className='d-flex flex-end align-items-center gap-2'>
                                                            {/* <span className='status_badge date_badge'>Jan 24, 2025</span> */}
                                                            <button className='delete-btn' onClick={() => {

                                                                dispatch(removeFromCart(c._id));
                                                                dispatch(unmarkItemAsAdded(c._id))
                                                            }}><img src="/assets/icons/delete-red-icon.svg" /></button>
                                                        </div>
                                                        <div className='cart_page_qty_blk'>
                                                            <div className="value-button" id="decrease" value="Decrease Value"
                                                                onClick={() => {
                                                                    // const newQty = Math.max(c.quantity - 1, 0);
                                                                    // if (newQty === 0) {
                                                                    //     dispatch(removeFromCart(c._id));
                                                                    //     dispatch(unmarkItemAsAdded(c._id))

                                                                    // } else {
                                                                    //     dispatch(addToCart({ ...c, quantity: newQty }));
                                                                    // }
                                                                    if (c.quantity <= 1) {
                                                                        // Do nothing if quantity is already 1
                                                                        return;
                                                                    }
                                                                    const newQty = Math.max(c.quantity - 1, 0);
                                                                    // setQuantities((q) => ({ ...q, [product._id]: newQty }));
                                                                    dispatch(addToCart({ ...c, quantity: newQty }));

                                                                }}
                                                            >-</div>
                                                            <input type="text" className='form-control' id="number" defaultValue={0} value={c.quantity} />
                                                            <div className="value-button" id="increase" value="Increase Value"
                                                                onClick={() => {
                                                                    const newQty = c.quantity + 1;
                                                                    dispatch(addToCart({ ...c, quantity: newQty }))
                                                                }
                                                                }
                                                            >+</div>
                                                        </div>
                                                    </div>
                                                )

                                            }) : (<p>No items in cart</p>)}

                                            {/* status card 1 */}

                                            {/* status card 1 */}
                                            {/* <div className='inner_outline_card hstack align-items-start m-0 position-relative w-100'>
                                                <div className='product_item hstack align-items-start'>
                                                    <div className='product_img'>
                                                        <img src="/assets/images/fruit-apple.png" alt="product" />
                                                    </div>
                                                    <div className='product_info'>
                                                        <div className='product_title_blk'>
                                                            <h3 className='product_name fs-6 fw-bold mb-0'>Apple</h3>
                                                        </div>
                                                        <ul className='product_title_info list-unstyled mb-0'>
                                                            <li><span className='card_product_title fw-medium'>Quantity -</span><span className='card_value'>10kg</span></li>
                                                            <li><span className='card_product_title fw-medium'>Type -</span><span className='card_value'>$3/Kg</span></li>
                                                            <li><span className='card_product_title fw-medium'>Price -</span><span className='card_value'>$3/Kg</span></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className='d-flex flex-end align-items-center gap-2'>
                                                    <span className='status_badge date_badge'>Jan 24, 2025</span>
                                                    <button className='delete-btn'><img src="/assets/icons/delete-red-icon.svg" /></button>
                                                </div>
                                                <div className='cart_page_qty_blk'>
                                                    <div className="value-button" id="decrease" onclick="decreaseValue()" value="Decrease Value">-</div>
                                                    <input type="number" className='form-control' id="number" defaultValue={0} />
                                                    <div className="value-button" id="increase" onclick="increaseValue()" value="Increase Value">+</div>
                                                </div>
                                            </div> */}

                                        </div>
                                        {/* <div className='add_more_product d-flex justify-content-center mt-3'>
                                            <a href='javascript:void(0)'>Add more products </a>
                                        </div> */}
                                    </div>
                                    <div className='col-md-5'>
                                        <div className='input_section'>
                                            <div className="input_wrapper">
                                                <label>Expected Date</label>
                                                <div className="form_field">
                                                    <input className={`form-control ${validationErrors.date ? 'is-invalid' : ''}`} placeholder="" type="date" min={new Date().toISOString().split("T")[0]} value={selectedDate}
                                                        onChange={(e) => {
                                                            setSelectedDate(e.target.value);
                                                            if (validationErrors.date) {
                                                                setValidationErrors(prev => ({ ...prev, date: false }))
                                                            }
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="input_wrapper">
                                                <label>Expected Time</label>
                                                <div className="form_field">
                                                    <input className={`form-control ${validationErrors.time ? 'is-invalid' : ''}`} placeholder="" type="time" value={selectedTime}
                                                        onChange={(e) => {
                                                            setSelectedTime(e.target.value);
                                                            if (validationErrors.time) {
                                                                setValidationErrors(prev => ({ ...prev, time: false }))
                                                            }
                                                        }} />
                                                </div>
                                            </div>
                                        </div>
                                        {cartItems.length > 0 && recurring &&
                                            <div className='set_reccur_btn_blk'>
                                                <button className='gray_ouline_btn' data-bs-toggle="modal" data-bs-target="#recurringModal" onClick={() => setRecurring(true)}>Set recurring order</button>
                                            </div>}
                                        {value && <div className='outline_product_card_list mt-4'>
                                            <div className='product_card_header hstack justify-content-between gap-3'>
                                                <h2 className='h5 fw-bold mb-0'>Recurring Order</h2>
                                            </div>
                                            <div className=''>
                                                <div className='product_info_blk bg-white hstack justify-content-between gap-3'>
                                                    <h3 className='fs-14 fw-medium mb-0'>Delivery Frequency </h3>
                                                    <p className='fs-14 fw-medium mb-0'>{value}</p>
                                                </div>
                                            </div>
                                            <div className=''>
                                                {selectedWeekdays && <div className='product_info_blk bg-white hstack justify-content-between gap-3'>
                                                    <h3 className='fs-14 fw-medium mb-0'>Repeat Every</h3>
                                                    <p className='fs-14 fw-medium mb-0'>{selectedWeekdays.map(index => weekdays[index]).join(', ')}</p>
                                                </div>}
                                            </div>
                                            <div className=''>
                                                {recurringTime && <div className='product_info_blk bg-white hstack justify-content-between gap-3'>
                                                    <h3 className='fs-14 fw-medium mb-0'>Time</h3>
                                                    <p className='fs-14 fw-medium mb-0'>{recurringTime}</p>
                                                </div>}
                                            </div>
                                            <div className=''>
                                                {selectedMonth && <div className='product_info_blk bg-white hstack justify-content-between gap-3'>
                                                    <h3 className='fs-14 fw-medium mb-0'>Month</h3>
                                                    <p className='fs-14 fw-medium mb-0'> {month[Number(selectedMonth)]}</p>
                                                </div>}
                                            </div>
                                            <div className=''>
                                                {selectedWeek && <div className='product_info_blk bg-white hstack justify-content-between gap-3'>
                                                    <h3 className='fs-14 fw-medium mb-0'>Week</h3>
                                                    <p className='fs-14 fw-medium mb-0'>{selectedWeek}</p>
                                                </div>}
                                            </div>
                                        </div>
                                        }


                                        <div className='outline_product_card_list mt-4'>
                                            <div className='product_card_header hstack justify-content-between gap-3'>
                                                <h2 className='h5 fw-bold mb-0'>Order Details</h2>
                                            </div>
                                            <div className=''>
                                                <div className='product_info_blk bg-white hstack justify-content-between gap-3'>
                                                    <h3 className='fs-14 fw-medium mb-0'>Sub Total  </h3>
                                                    <p className='fs-14 fw-medium mb-0'>${subtotal}</p>
                                                </div>
                                            </div>
                                            <div className='product_total_blk hstack justify-content-between gap-3'>
                                                <h3 className='fs-5 fw-semibold mb-0'>Total</h3>
                                                <p className='fs-5 fw-semibold mb-0'>${subtotal}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='hstack flex-end gap-2 mt-4'>
                                <button className={`${isHandleSubmit ? 'primary-btn fs-14 fw-semibold' : 'primary-btn disabled'}`} onClick={handleSubmitRequest}>Submit Request</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            {/* <!-- Recurring Modal --> */}
            < div className="modal fade" id="recurringModal" tabIndex={- 1
            } aria-labelledby="recurringModalLabel" aria-hidden="true" ref={modalRef} >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header text-center">
                            <h1 className="modal-title fs-5 text-center w-100" id="recurringModalLabel">Repeat Frequency</h1>
                            <button type="button" className="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body p-4">
                            <div className='repeat_frequency_select_field'>
                                <div className='selective_radio'>
                                    <input type='radio' id='repeatNot' name="repeatFrequency" className='d-none' checked={value === 'no repeat'} onClick={() => {
                                        setValue('no repeat');
                                        setBottomBar(false);
                                        setTimeField(false);
                                        setDateField(false);
                                        setWeek(false);
                                        setMonthField(false);
                                    }} />
                                    <label htmlFor='repeatNot'>Does not repeat</label>
                                </div>
                                <div className='selective_radio'>
                                    <input type='radio' id='repeatEvery' name="repeatFrequency" className='d-none' checked={value === 'every weekday'} onClick={() => {
                                        setValue('every weekday');
                                        setBottomBar(true)
                                        setDateField(true);
                                        setTimeField(true);
                                        setWeek(false);
                                        setMonthField(false);
                                    }} />
                                    <label htmlFor='repeatEvery'>Every weekday</label>
                                </div>
                                <div className='selective_radio'>
                                    <input type='radio' id='repeatDaily' name="repeatFrequency" className='d-none' checked={value === 'daily'} onClick={() => {
                                        setValue('daily');
                                        setBottomBar(true);
                                        setTimeField(true);
                                        setDateField(false);
                                        setWeek(false);
                                        setMonthField(false);
                                    }} />
                                    <label htmlFor='repeatDaily'>Daily</label>
                                </div>
                                <div className='selective_radio'>
                                    <input type='radio' id='repeatWeekly' name="repeatFrequency" className='d-none' checked={value === 'weekly'} onClick={() => {
                                        setValue('weekly');
                                        setBottomBar(true)
                                        setDateField(true);
                                        setTimeField(true);
                                        setWeek(false);
                                        setMonthField(false);
                                    }} />
                                    <label htmlFor='repeatWeekly'>Weekly</label>
                                </div>
                                <div className='selective_radio'>
                                    <input type='radio' id='repeatMonthly' name="repeatFrequency" className='d-none' checked={value === 'monthly'} onClick={() => {
                                        setValue('monthly');
                                        setBottomBar(true)
                                        setDateField(true);
                                        setTimeField(true);
                                        setWeek(true);
                                        setMonthField(false);
                                    }} />
                                    <label htmlFor='repeatMonthly'>Monthly</label>
                                </div>
                                <div className='selective_radio'>
                                    <input type='radio' id='repeatYearly' name="repeatFrequency" className='d-none' checked={value === 'yearly'} onClick={() => {
                                        setValue('yearly');
                                        setBottomBar(true)
                                        setDateField(true);
                                        setTimeField(true);
                                        setWeek(true);
                                        setMonthField(true);
                                    }} />
                                    <label htmlFor='repeatYearly'>Yearly</label>
                                </div>
                            </div>
                            {bottomBar &&
                                (
                                    <div className='repeat_frequency_result'>
                                        {timeField &&
                                            (
                                                <div className='select_data hstack justify-content-between gap-3'>
                                                    <h3 className='fs-6 fw-medium mb-0'>Time</h3>
                                                    {/* <span id='clockpicker' className='toggle_data_field'
                                                    >10 AM</span> */}
                                                    <input className={`form-control`} placeholder="" type="time" value={recurringTime} onChange={(e) => {
                                                        setRecurringTime(e.target.value)
                                                    }
                                                    }
                                                    />
                                                </div>
                                            )}

                                        {dateField && (
                                            <div className='select_data hstack justify-content-between gap-3'>
                                                <h3 className='fs-6 fw-medium mb-0'>Every</h3>
                                                {/* <span className='toggle_data_field' data-bs-toggle='modal' data-bs-target='#weekdaysModal'>Monday, Friday</span> */}
                                                <span className='toggle_data_field dropdown-toggle' data-bs-toggle="dropdown" aria-expanded="false">
                                                    {selectedWeekdays.length > 0
                                                        ? selectedWeekdays
                                                            .map(index => weekdays[index])  // Convert index to day name
                                                            .join(', ')
                                                        : 'Select Days'}
                                                </span>
                                                <ul class="dropdown-menu dropdown-menu-end">
                                                    <li>
                                                        <select
                                                            className='form-select border-0'
                                                            multiple
                                                            value={selectedWeekdays}
                                                            onChange={(e) => {
                                                                const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
                                                                setSelectedWeekdays(selectedOptions);
                                                            }}
                                                        >
                                                            {weekdays?.map((w, index) => (
                                                                <option key={index} value={index}>{w}</option>
                                                            ))}
                                                        </select>
                                                    </li>
                                                </ul>
                                            </div>
                                        )}
                                        {week &&
                                            <div className='select_data hstack justify-content-between gap-3'>
                                                <h3 className='fs-6 fw-medium mb-0'>Week</h3>
                                                {/* <span className='toggle_data_field' data-bs-toggle='modal' data-bs-target='#weekdaysModal'>Monday, Friday</span> */}
                                                <span className='toggle_data_field dropdown-toggle' data-bs-toggle="dropdown" aria-expanded="false">
                                                    {selectedWeek
                                                        ? selectedWeek
                                                        : 'Select Week'}
                                                </span>
                                                <ul class="dropdown-menu dropdown-menu-end">
                                                    <li>
                                                        <select
                                                            className='form-select border-0'
                                                            value={selectedWeek}
                                                            size={3}
                                                            onChange={(e) => {
                                                                // const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
                                                                setSelectedWeek(e.target.value);
                                                            }}
                                                        >
                                                            {weeks?.map((w, index) => (
                                                                <option key={index} value={w}>{w}</option>
                                                            ))}
                                                        </select>
                                                    </li>
                                                </ul>
                                            </div>}
                                        {monthField &&
                                            <div className='select_data hstack justify-content-between gap-3'>
                                                <h3 className='fs-6 fw-medium mb-0'>Month</h3>
                                                {/* <span className='toggle_data_field' data-bs-toggle='modal' data-bs-target='#weekdaysModal'>Monday, Friday</span> */}
                                                <span className='toggle_data_field dropdown-toggle' data-bs-toggle="dropdown" aria-expanded="false">
                                                    {selectedMonth
                                                        ? selectedMonth
                                                        : 'Select Month'}
                                                </span>
                                                <ul class="dropdown-menu dropdown-menu-end">
                                                    <li>
                                                        <select
                                                            className='form-select border-0'
                                                            value={selectedMonth}
                                                            size={3}
                                                            onChange={(e) => {
                                                                // const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
                                                                setSelectedMonth(e.target.value);
                                                            }}
                                                        >
                                                            {month?.map((m, index) => (
                                                                <option key={index} value={index}>{m}</option>
                                                            ))}
                                                        </select>
                                                    </li>
                                                </ul>
                                            </div>}

                                    </div>

                                )}

                            {/* <div className='repeat_frequency_result'>
                                <div className='select_data hstack justify-content-between gap-3' data-bs-toggle="collapse" href="#specificDate" role="button" aria-expanded="false" aria-controls="specificDate">
                                    <h3 className='fs-6 fw-medium mb-0'>Specific Date</h3>
                                    <span className='toggle_data_field'
                                    ></span>
                                </div>
                                <div className="collapse multi-collapse" id="specificDate">
                                    <div className="card card-body border-0">
                                        Some placeholder content for the first collapse component of this multi-collapse example. This panel is hidden by default but revealed when the user activates the relevant trigger.
                                    </div>
                                </div>

                                <div className='select_data hstack justify-content-between gap-3' data-bs-toggle="collapse" href="#relativeDate" role="button" aria-expanded="false" aria-controls="relativeDate">
                                    <h3 className='fs-6 fw-medium mb-0'>Relative Date</h3>
                                    <span className='toggle_data_field'></span>
                                </div>
                                <div className="collapse multi-collapse" id="relativeDate">
                                    <div className="card card-body border-0">
                                        Some placeholder content for the first collapse component of this multi-collapse example. This panel is hidden by default but revealed when the user activates the relevant trigger.
                                    </div>
                                </div>

                            </div> */}

                            <button
                                className='btn btn-primary mt-3 m-auto'
                                onClick={() => {
                                    if (value === 'no repeat') {
                                        closeModal();
                                    } else if ((timeField && !recurringTime) || (dateField && !selectedWeekdays)) {
                                        alert('Please select all required fields');
                                    } else {
                                        closeModal();
                                    }
                                }}
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            </div >



            {/* weekdays select modal */}

            < div className="modal fade" id="weekdaysModal" tabIndex={- 1
            } aria-labelledby="weekdaysModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        {/* <div className="modal-header text-center">
                            <h1 className="modal-title fs-5 text-center w-100" id="weekdaysModalLabel">Repeat Frequency</h1>
                            <button type="button" className="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close" />
                        </div> */}
                        <div className="modal-body p-4">
                            {/* <div className='repeat_frequency_select_field'>
                                <div className='selective_radio'>
                                    <input type='radio' id='Monday' name="weekdays" className='d-none' />
                                    <label htmlFor='Monday'>Monday</label>
                                </div>
                                <div className='selective_radio'>
                                    <input type='radio' id='Tuesday' name="weekdays" className='d-none' />
                                    <label htmlFor='Tuesday'>Tuesday</label>
                                </div>
                                <div className='selective_radio'>
                                    <input type='radio' id='Wednesday' name="weekdays" className='d-none' />
                                    <label htmlFor='Wednesday'>Wednesday</label>
                                </div>
                                <div className='selective_radio'>
                                    <input type='radio' id='Thursday' name="weekdays" className='d-none' />
                                    <label htmlFor='Thursday'>Thursday</label>
                                </div>
                                <div className='selective_radio'>
                                    <input type='radio' id='Friday' name="weekdays" className='d-none' />
                                    <label htmlFor='Friday'>Friday</label>
                                </div>
                                <div className='selective_radio'>
                                    <input type='radio' id='Saturday' name="weekdays" className='d-none' />
                                    <label htmlFor='Saturday'>Saturday</label>
                                </div>
                                <div className='selective_radio'>
                                    <input type='radio' id='Sunday' name="weekdays" className=' d-none' />
                                    <label htmlFor='Sunday'>Sunday</label>
                                </div>
                            </div> */}

                            <div className='repeat_frequency_select_field'>

                                {weekdays.map(day => (
                                    <div className='selective_radio' key={day}>
                                        <input
                                            type='checkbox'
                                            id={day}
                                            className='d-none'
                                            checked={selectedWeekdays.includes(day)}
                                            onChange={() => handleCheckboxChange(day)}
                                        />
                                        <label htmlFor={day}>{day}</label>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
            </div >

        </>
    )
}

export default Cart
